import { AuthUser } from '@bossanova/models';
import { InjectionToken } from '@angular/core';

export interface AppConfig {
  apiUrl: string;
}

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG');
export const INITIAL_AUTH_USER = new InjectionToken<AuthUser | null>(
  'INITIAL_AUTH_USER',
);
